module.exports = __webpack_public_path__ + "img/jun-22-small.89a12fb8.jpeg";